import { Icon } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { DysplasiaApi, DysplasiaGridDto, DysplasiaSearch, ECommissionType } from "../../api";
import { ERoutes } from "../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../components";
import { useGlobalData } from "../../contexts";
import { useApiService, useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { Link } from "react-router-dom";
import { IconNames } from "@blueprintjs/icons";
import assets from "../../assets";

export interface IDysplasiaListProps {
  isAppeal: boolean;
  comissionType?: ECommissionType;
  breadcrumbText: ETLCodes;
}

export const DysplasiaList: React.FunctionComponent<IDysplasiaListProps> = ({
  isAppeal,
  breadcrumbText,
  comissionType = null,
}) => {
  const api = useApiService(DysplasiaApi);
  const { currentLanguage } = useGlobalData();
  const history = useHistory();
  const { t } = useTl();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: DysplasiaGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() =>
                history.push(
                  `${
                    isAppeal
                      ? ERoutes.appealDysplasia
                      : comissionType === ECommissionType.ClassicCommission
                      ? ERoutes.commissionDysplasia
                      : ERoutes.gentCommission
                  }/${row.dysplasiaRequestId}/evaluation/view`
                )
              }
            />
            <EditButton
              minimal={true}
              onClick={() =>
                history.push(
                  `${
                    isAppeal
                      ? ERoutes.appealDysplasia
                      : comissionType === ECommissionType.ClassicCommission
                      ? ERoutes.commissionDysplasia
                      : ERoutes.gentCommission
                  }/${row.dysplasiaRequestId}/evaluation/edit`
                )
              }
            />
          </ButtonContainer>
        ),
      },
      {
        computed: true,
        disableSorting: true,
        fieldName: "reevaluation",
        autoFitContent: true,
        render: (row: DysplasiaGridDto) =>
          row?.reEvaluation && <Icon icon={IconNames.WARNING_SIGN} style={{ color: "RED" }} />,
      },
      {
        header: () => t(ETLCodes.RequestDate),
        fieldName: "requestDate",
      },
      {
        header: () => t(ETLCodes.RequestNumber),
        fieldName: "requestNumber",
      },
      {
        header: () => t(ETLCodes.BirthDate),
        fieldName: "birthDate",
      },
      {
        header: () => t(ETLCodes.Breed),
        fieldName: "breed",
        render: (row: DysplasiaGridDto) => (
          <Link target="_blank" to={`${ERoutes.breeds}/${row.breedId}/detail/view`}>
            {row.breed}
          </Link>
        ),
      },
      // ...dysplasiaTypes
      //   ?.filter((dt) => {
      //     return dt;
      //   })
      //   .map((dt) => ({
      //     header: () => tUnsafe(dt.code),
      //      computed: true,
      //disableSorting: true,
      //     fieldName: "types",
      //     render: (row: DysplasiaGridDto) => (
      //       <Checkbox checked={row.dysplasiaTypeIdsChecked.some((e) => e === dt.dysplasiaTypeId)} />
      //     ),
      //   })),
    ],
    [comissionType, history, isAppeal, t]
  );

  const search = React.useCallback(
    (sObj) =>
      api.baseSearch(
        DysplasiaSearch.fromJS({
          ...sObj,
          isAppeal: isAppeal,
          languageId: currentLanguage.languageId,
          commissionType: comissionType,
        })
      ),
    []
  );

  return (
    <SearchTablePage
      columns={columns}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(
          DysplasiaSearch.fromJS({
            ...sObj,
            isAppeal: isAppeal,
            languageId: currentLanguage.languageId,
            commissionType: comissionType,
          })
        )
      }
      sortKeys={{ requestDate: "DESC" }}
      breadCrumbs={[{ text: t(breadcrumbText) }]}
      imageSource={assets.images.dyslasie}
    />
  );
};
